import React, { FC, InputHTMLAttributes, memo } from 'react';
import Label from 'components/label/label';
import { ReactSVG } from 'react-svg';

import './styles.scss';

interface ITextInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value'> {
  value: string;
  iconPath?: string;
  radio?: boolean;
  label?: string;
}

const TextInput: FC<ITextInputProps> = ({
  value,
  iconPath,
  radio,
  label,
  required,
  disabled,
  ...props
}) => {
  return (
    <div className="input-block">
      {iconPath ? (
        <ReactSVG
          className={`input-block-icon ${radio ? 'radio' : ''}`}
          src={iconPath}
        />
      ) : (
        ''
      )}
      {label && <Label label={label} required={required} htmlFor="input" />}
      <input
        id="input"
        className={`input-block-field ${iconPath ? 'iconned' : ''} ${
          radio ? 'radio' : ''
        }`}
        title={disabled ? value : ''}
        value={value}
        {...props}
      />
    </div>
  );
};

export default memo(TextInput);
